export const titleHeadingStyle = {
  fontWeight: 'bold',
  fontSize: '25px',
};

export const titleHeadingStyleSmole = {
  fontWeight: 'bold',
  fontSize: '15px',
};
